import { useState } from "react";
import { Form, Modal, Row, Col, Radio, Input } from "antd";
import lang from "../helper/langHelper";
import { Severty, ShowToast } from "../helper/toast";
import useRequest from "../hooks/useRequest";

const SendNotification = ({api,data, show, hide, onOk, title, subtitle ,refresh }) => {
  // const [value, setValue] = useState(reasons?.length > 0 ? reasons[1] : "");
const [loading,setLoading] = useState(false)
const {request} = useRequest()
const [form] = Form.useForm() 


  const onCreate = (values) => {

    const payload = {...values};
    setLoading(true);
    request({
      url: `${api.addEdit}/send-notification/${data?._id}`,
      method:  "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };
  return (
    <Modal
      width={500}
      open={show}
      // onOk={onCreate}
      okText={"Ok"}
      cancelText={"Cancel"}
      onCancel={hide}
      centered
      className="tab_modal deleteWarningModal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
  
    >
      <Form layout="vertical" id="create" className="p-2" loading={loading} disabled={loading} form={form}  onFinish={onCreate}>
        <h4 className="modal_title_cls mb-2">{title}</h4>
        <h6 className="modal_sub_title_cls mb-2">{subtitle}</h6>
        <Row gutter={[16, 0]} className="w-100">
          <Col style={{margin:"auto"}} span={24} sm={24} md={24}>
            <Form.Item
              name="message"
              rules={[
                {
                  required: true,
                  message: "Please Enter Notification Message"
                },
                {
                  max: 200,
                  message: "Message should not contain more then 200 characters!"
                },
                {
                  min: 2,
                  message: "Message should contain at least 2 characters!"
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                autoComplete="off"
                placeholder="Enter Notification Message"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SendNotification;
